
import ObjectCard from '../../components/Card/ObjectCard.vue'
import { getCustomTabsList } from './stockCardCustomTabs.js'

export default {
  name: 'StockCard',
  extends: ObjectCard,
  data: function () {
    return {
      typeKeyLocal: 'stock', // @Override
      typeShownLocal: true
    }
  },
  methods: {
    /**
     * ObjectCard
     */
    // @Override
    setObjectType: function (objectTypeKey) {
      // ignore Иначе typeKeyLocal перезапишется
    },
    // @Override
    getRawCustomTabsList: function (config) {
      return getCustomTabsList(config)
    },
    // @Default
    checkUserAccess: function (user) {
      const access = this.getDefaultAccess()

      access.editPrivate = false // user.fullAccess
      access.viewPrivate = user.fullAccess
      access.viewPublic = true
      access.viewStockInventoryTasks = user.hasOperation('stockInventoryManagement') || user.hasOperation('stockInventoryApproval') || user.hasOperation('stockInventoryAdministration')
      access.editPublic = false // user.hasRole('admin')

      access.editOrganizationProject = false // user.hasRole('admin')
      access.editAny = access.editPublic || access.editOrganizationProject
      return access
    }
  }
}
